import React, { useEffect, useState } from "react";
import { I, T } from "services/lang/LanguageService";
import { Instant } from "@js-joda/core";
import useIsMobile from "hooks/useIsMobile";
import { IDashboardComponent } from "api/model/dashboard/DashboardComponent";
import ComponentContextWrapper from "../context/ComponentContextWrapper";
import getDashboardComponentClassName from "./GroupComponentUtils";
import "../../dashboard-styles/Dashboard.scss";

interface IDashboardComponentCardProps {
  component: IDashboardComponent;
  tabId: number;
  groupId: string;
  isGroupHeader?: boolean;
  onCollapseChange?: (isCollapsed: boolean) => void;
  isReports?: boolean;
  refTime?: Instant;
}

const DashboardComponentCard = ({
  component,
  tabId,
  groupId,
  isGroupHeader,
  onCollapseChange,
  isReports,
  refTime,
}: IDashboardComponentCardProps) => {
  const isMobile = useIsMobile();
  const [isCollapsed, setIsCollapsed] = useState<boolean>(
    (component.collapsable && component.isCollapsed) ?? false
  );

  const toggleCollapse = () => {
    setIsCollapsed(prev => {
      const newVal = !prev;
      onCollapseChange?.(newVal);
      return newVal;
    });
  };

  useEffect(() => {
    setIsCollapsed((component.collapsable && component.isCollapsed) ?? false);
  }, [component.collapsable, component.isCollapsed]);

  return (
    <div className={getDashboardComponentClassName(component, isGroupHeader)}>
      {component.collapsable && (
        <div className="flex flex-row justify-content-between">
          <i
            className={`pi ${isCollapsed ? "pi-plus" : "pi-minus"}`}
            onClick={toggleCollapse}
            aria-label={isCollapsed ? T("action.expand") : T("action.collapse")}
            style={{ fontSize: "1.5rem" }}
          />
          {isCollapsed && (
            <div className="flex align-items-start">
              {component.title && !isMobile && (
                <h4 className={`text-${component.titleSize}`}>{I(component.title)}</h4>
              )}
              {component.title && isMobile && <h6>{I(component.title)}</h6>}
            </div>
          )}
          <div />
        </div>
      )}
      {component.type !== "SEPARATOR" && !isCollapsed && (
        <div className="flex flex-column h-full">
          {component.title && !isMobile && !isGroupHeader && (
            <h4 className={`text-${component.titleSize} text-${component.titleAlign}`}>
              {I(component.title)}
            </h4>
          )}
          {component.title && isMobile && !isGroupHeader && <h6>{I(component.title)}</h6>}
          <div className="easas-dashboard-component-content">
            <ComponentContextWrapper
              component={component}
              tabId={tabId}
              groupId={groupId}
              isGroupHeader={isGroupHeader}
              isReports={isReports}
              refTime={refTime}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardComponentCard;
